// eslint-disable-next-line @nx/enforce-module-boundaries
import { CompaniesManagementPage } from '@insurance/features/companies-management/pages'
import { paths } from '@organization/router'
import { useNavigate } from 'react-router-dom'

export const CompaniesPartnerManagementPage = () => {
  const navigate = useNavigate()

  return (
    <CompaniesManagementPage
      onNameClick={({ id }) => navigate(paths.partners.agents(id))}
    />
  )
}
